(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminJobDisplaySettingsController', AdminJobDisplaySettingsController);

    function AdminJobDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'job_acceptance_terms_file',
                'job_acceptance_terms_text',
                'job_satisfaction_survey_frequency',
                'job_group_child_select_mandatory',
                'allow_secondary_approvers_to_reopen_jobs',
                'job_reporter_feedback',
                'job_complete_email_text'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
    }
})();
